class PlpEditorial extends window.BAO.CustomElement() {
  connectedCallback () {
    if (!this.els.block) return

    // An array of the empty blocks elements, ready to be populated
    this.blockArray = []
    this.loadedBlockIndices = []
    this.preloadBlocksCount = parseInt(this.dataset.preloadBlocksCount, 10)

    // Using the ?block query string, retrieve the indices of the blocks to be restored
    this.blocksToRestore = this.getBlocksToRestore()

    this.init()
  }

  async init () {
    // Fetch content for all blocks
    await this.getBlocks()

    // Now we have the block content, we can restore the relevant blocks
    this.restoreBlocks()

    // ...and watch for when subsequent empty blocks come into view
    this.setupIntersectionObserver()
  }

  setupIntersectionObserver () {
    const options = {
      threshold: 0,
    }

    // eslint-disable-next-line compat/compat
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.showBlock(entry.target, true)
        }
      })
    }, options)

    this.els?.block?.elements.forEach(block => {
      observer.observe(block)
    })
  }

  async getBlocks () {
    const storage = sessionStorage.getItem(this.storageName)

    if (!storage) {
      return window.BAO.sectionRenderer
        .fetch(this.dataset.id, `${window.location.href}`)
        .then(res => {
          const newDOM = window.BAO.sectionRenderer.convertToDOM(
            res[this.dataset.id],
          )

          const blocksContainer = newDOM.querySelector(this.els.blocks.selector)
          sessionStorage.setItem(this.storageName, blocksContainer.outerHTML)

          this.blockArray = newDOM.querySelectorAll(this.els.block.selector)
        })
        .catch(() => {})
    } else {
      const parser = new DOMParser()
      const doc = parser.parseFromString(storage, 'text/html')

      const container = doc.body.firstElementChild
      this.blockArray = container.querySelectorAll(this.els.block.selector)
    }
  }

  showBlock (block, updateUrl = false, dispatchEvent = false) {
    const blockIndex = parseInt(block.dataset.blockIndex0, 10)

    // Only load the block if it hasn't been loaded yet
    if (
      this.loadedBlockIndices.includes(blockIndex) ||
      blockIndex < this.preloadBlocksCount
    ) {
      return
    }

    if (updateUrl) this.updateUrl(blockIndex + 1)

    if (this.blockArray[blockIndex]) {
      block.innerHTML = this.blockArray[blockIndex]?.innerHTML

      block.setAttribute('data-blocked-loaded', 'true')

      this.loadedBlockIndices.push(blockIndex)

      if (dispatchEvent) {
        document.dispatchEvent(new CustomEvent('collectionRendered'))
      }
    }

    try {
      if (typeof iWish !== 'undefined') {
        setTimeout(() => {
          /* eslint-disable-next-line no-undef */
          iWish.checkIwishColl()
        }, 1500)
      }
    } catch (error) {
      console.warn(error)
    }
  }

  restoreBlocks () {
    if (
      !Array.isArray(this.blocksToRestore) ||
      this.blocksToRestore.length <= 0 ||
      !this.els?.block?.elements
    ) {
      return
    }
    this.blocksToRestore.forEach((blockIndex, index) => {
      const isLast = index === this.blocksToRestore.length - 1
      const blockElement = this.els?.block?.elements.find(
        el => el.getAttribute('data-block-index') === String(blockIndex),
      )
      if (blockElement) this.showBlock(blockElement, false, isLast)
    })
  }

  updateUrl (blockIndex = false) {
    const url = new URL(window.location)

    if (blockIndex) {
      url.searchParams.set('block', blockIndex)
    } else {
      url.searchParams.delete('block')
    }

    window.history.pushState({}, '', url)
  }

  getBlocksToRestore () {
    const params = new URLSearchParams(window.location.search)
    const blockValue = parseInt(params.get('block'), 10)

    // Return an empty array if blockValue is not a number or is within the preloadBlocksCount
    if (isNaN(blockValue) || blockValue <= this.preloadBlocksCount) {
      return []
    }

    // Return an array of block indexes that need to be updated
    const blocksToUpdate = []
    for (let i = this.preloadBlocksCount + 1; i <= blockValue; i++) {
      blocksToUpdate.push(i)
    }

    return blocksToUpdate
  }

  get storageName () {
    return `BAO-plp-editorial-${this.dataset.templateSuffix}-${this.dataset.templateVersion}`
  }
}

if (!customElements.get('plp-editorial')) {
  customElements.define('plp-editorial', PlpEditorial)
}
